<template>
  <div>
    <calling-staff-modal />
    <checkout-modal />
    <qr-for-children-modal />
    <tutorial-modal />
    <simple-error-modal />
    <scheduled-recommend-modal />
    <birth-month-event-modal />
    <reserve-info-modal />
    <voice-search-modal />
    <pre-order-warning-modal />
    <order-quitting-modal />
    <selfcheck-modal />
    <selfcheck-calling-modal-container />
    <selfcheck-loading-modal-container />
    <selfcheck-error-modal />
    <selfcheck-init-error-modal />
    <selfcheck-unhandled-error-modal />
  </div>
</template>

<script>
import OrderQuittingModal from '@/components/modal/OrderQuittingModal'
import TutorialModal from '@/components/modal/TutorialModal'
import QrForChildrenModal from '@/components/modal/QrForChildrenModal'
import CallingStaffModal from '@/components/modal/CallingStaffModal'
import ScheduledRecommendModal from '@/components/modal/ScheduledRecommendModal'
import CheckoutModal from '@/components/modal/CheckoutModal'
import SimpleErrorModal from '@/components/modal/SimpleErrorModal'
import BirthMonthEventModal from '@/components/modal/BirthMonthEvent'
import ReserveInfoModal from '@/components/modal/ReserveInfoModal'
import VoiceSearchModal from '@/components/modal/VoiceSearchModal'
import PreOrderWarningModal from '@/components/modal/PreOrderWarningModal'
import SelfcheckModal from '@/components/modal/SelfcheckModal'
import SelfcheckCallingModalContainer from '@/components/modal/SelfcheckCallingModal.container'
import SelfcheckLoadingModalContainer from '@/components/modal/SelfcheckLoadingModal.container'
import SelfcheckErrorModal from '@/components/modal/SelfcheckErrorModal'
import SelfcheckInitErrorModal from '@/components/modal/SelfcheckInitErrorModal'
import SelfcheckUnhandledErrorModal from '@/components/modal/SelfcheckUnhandledErrorModal'

export default {
  components: {
    OrderQuittingModal,
    TutorialModal,
    QrForChildrenModal,
    CallingStaffModal,
    ScheduledRecommendModal,
    CheckoutModal,
    SimpleErrorModal,
    BirthMonthEventModal, // 誕生月イベントモーダル
    ReserveInfoModal,
    VoiceSearchModal,
    PreOrderWarningModal,
    SelfcheckModal,
    SelfcheckCallingModalContainer,
    SelfcheckLoadingModalContainer,
    SelfcheckErrorModal,
    SelfcheckInitErrorModal,
    SelfcheckUnhandledErrorModal,
  },
}
</script>

<style lang="scss">
@media (max-width: 575px) {
  .modal-dialog {
    margin-left: 24px !important;
    margin-right: 24px !important;
  }
}
.modal-body {
  padding-left: 24px !important;
  padding-right: 24px !important;
}
</style>
